import type { LegalConsentItem } from './types'

/**
 * Resolves the display text for a legal-consent item: prefers the
 * translation at `item.i18nKey` when one exists, otherwise falls back to
 * the platform-configured `item.text` — the same "translation-exists, else
 * fallback" idiom already used at `src/modules/leads/LeadList/List.vue:510`
 * — so an item always renders something even before its translation is set
 * up in Locize.
 */
export function resolveConsentItemText(
  item: LegalConsentItem,
  t: (key: string) => string,
  te: (key: string) => boolean
): string {
  return item.i18nKey && te(item.i18nKey) ? t(item.i18nKey) : item.text
}
